
@if (url) {
  <iframe id="mapHeight" class="iframe" title="Care member map" [src]="url"></iframe>
}
<!-- <agm-map
[latitude]="latitude"
[longitude]="longitude">
<agm-marker
  [latitude]="latitude"
[longitude]="longitude"></agm-marker>
</agm-map> -->

